import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";

export const Header = () => {

   let cartItem = useSelector((state)=>state.cart.total)

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const[pageHover,setpageHover]=useState(false)
  const[mobileNav,setMobileNav]=useState(false)
  const[isLoggedIn,setIsLoggedIn]=useState(Cookies.get('loginData'))

  const route=useLocation()

  

   const userId = useSelector((state) => state.user.userId);
  // const firstName=useSelector((state) => state.user.signupData.firstName ||state.user.loginData.firstName)

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    
    // Clean up on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  return (
    <div className="container-fluid fixed-top">
      <div className="container topbar bg-primary d-none bg-gradient-header d-lg-block">
        <div className="d-flex justify-content-between ">
          <div className="top-info ps-2">
            <small className="me-3">
              <i className="fas fa-map-marker-alt me-2 text-secondary" />{" "}
              <a href="#" className="text-white">
               Chakdaha,Nadia,West Bengal,741248
              </a>
            </small>
            <small className="me-3">
              <i className="fas fa-envelope me-2 text-secondary" />
              <a href="#" className="text-white">
                contact@rndsan.com
              </a>
            </small>
          </div>
          <div className="top-link pe-2">
            <a href="#" className="text-white">
              <small className="text-white mx-2">Privacy Policy</small>/
            </a>
            <a href="#" className="text-white">
              <small className="text-white mx-2">Terms of Use</small>/
            </a>
            <a href="#" className="text-white">
              <small className="text-white ms-2">Sales and Refunds</small>
            </a>
          </div>
        </div>
      </div>
      <div className="container px-0">
        <nav className=" bg-white flex items-center justify-between ">
         
          {isMobile?
           <div
            className="flex flex-end gap-[40px] w-[100%] items-center justify-between"
          >
            <a href="/" className="navbar-brand">
            <img src="Assets/LogoRndsan.jpeg" width="170px" />
            {/* <h1 className="text-primary display-6">RNDSAN</h1> */}
          </a>
          <button
            className="bg-white py-2 px-3"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            onClick={()=>setMobileNav(!mobileNav)}
          >
            <span className="fa fa-bars text-primary" />
          </button></div>
         : <div
            className="flex flex-end gap-[40px] w-[100%] items-center justify-between"
          >
             <a href="/" className="navbar-brand">
            <img src="Assets/LogoRndsan.jpeg" width="170px" />
            {/* <h1 className="text-primary display-6">RNDSAN</h1> */}
          </a>
            <div className=" min-w-fit"
            style={{display:"flex",alignItems:"center",justifyContent:"center",gap:"10px",color:"black",fontSize:"12px"}}>
              <a href="/" className=''>
               {route.pathname==="/"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px",fontWeight:"700"}}>Home</p>: "Home"}
              </a>
              <a href="/shop" className="">
                 {route.pathname==="/shop"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px",fontWeight:"700"}}>Shop</p>: "Shop"}
              </a>
              <a href="/service" className="">
                 {route.pathname==="/service"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px",fontWeight:"700"}}>Product-Service</p>: "Product-Service"}
              </a>
                <a href="/medical-test" className="">
                 {route.pathname==="/medical-test"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px",fontWeight:"700"}}>Medical-test</p>: "Medical-test"}
              </a>
              <a href="/question-review" className="">
                 {route.pathname==="/question-review"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px",fontWeight:"700"}}>Review</p>:"Review"}
              </a>
               <a href="/enquery" className="">
                     {route.pathname==="/enquery"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px",fontWeight:"700"}}>Enquery</p>: "Enquery"}
                  </a>
                  {/* <a href="/profile" className="nav-item nav-link">
                    <p>profile</p>
                  </a> */}
              
              <a href="/contact" className="">
                 {route.pathname==="/contact"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px"}}>Contact</p>: "Contact"}
              </a>
            </div>
            <div className="d-flex m-3 me-0 position-relative">
              <button
                className="btn-search btn border border-secondary btn-md-square rounded-circle bg-white me-4"
                data-bs-toggle="modal"
                data-bs-target="#searchModal"
              >
                <i className="fas fa-search text-primary" />
              </button>

              <a href="/cart" className="position-relative me-4 my-auto">
                <i className="fa fa-shopping-bag fa-2x" />
              {cartItem>0 &&  <span
                  className="position-absolute bg-secondary rounded-circle d-flex align-items-center justify-content-center text-dark px-1"
                  style={{ top: "-5px", left: 15, height: 20, minWidth: 20 }}
                >
                 {cartItem}
                </span>}
              </a>


              <div className="dropdown my-auto">
                <a
                  href="#"
                  role="button"
                  id="userDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fas fa-user fa-2x" />
                </a>
               {!userId && !isLoggedIn? <ul
                  className="dropdown-menu dropdown-menu-end shadow border-0 mt-2"
                  aria-labelledby="userDropdown"
                  style={{ minWidth: "200px", borderRadius: "10px" }}
                >
                  <li>
                    <h6 className="dropdown-header">Welcome!</h6>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/login">
                      <i className="fas fa-sign-in-alt me-2 text-primary"></i>{" "}
                      Login
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/register">
                      <i className="fas fa-user-plus me-2 text-success"></i>{" "}
                      Register
                    </a>
                  </li>
                </ul>
               : <ul
                  className="dropdown-menu dropdown-menu-end shadow border-0 mt-2"
                  aria-labelledby="userDropdown"
                  style={{ minWidth: "200px", borderRadius: "10px" }}
                >
                   <li className="bg-yellow-300 font-bold cursor-notallowed">
                    <a className="dropdown-item" href="/profile">
                      Welcome! user
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/profile">
                      <i className="fas bi bi-person-fill me-2 text-primary"></i>{" "}
                      Profile
                    </a>
                  </li>
                </ul>}
              </div>
            </div>
          </div>}

          
        </nav>
         {
           isMobile && mobileNav&&
           <div
            className="flex flex-col  gap-2 items-center justify-between"
          >
            <div className="flex flex-col gap-4 items-center">
              <a href="/" className='nav-item nav-link'>
               {route.pathname==="/"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px"}}>Home</p>: "Home"}
              </a>
              <a href="/shop" className="nav-item nav-link">
                 {route.pathname==="/shop"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px"}}>Shop</p>: "Shop"}
              </a>
              <a href="/service" className="nav-item nav-link">
                 {route.pathname==="/service"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px"}}>Service</p>: "Service"}
              </a>
               <a href="/medical-test" className="nav-item nav-link ink-item">
                 {route.pathname==="/medical-test"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px"}}>Medical-test</p>: "Medical-test"}
              </a>
              <a href="/question-review" className="nav-item nav-link">
                 {route.pathname==="/question-review"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px"}}>Review</p>: "Review"}
              </a>
               <a href="/enquery" className="nav-item nav-link">
                     {route.pathname==="/enquery"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px"}}>Enquery</p>: "Enquery"}
                  </a>
              
              <a href="/contact" className="nav-item nav-link">
                 {route.pathname==="/contact"?<p  style={{color:"red",padding:"5px",border:"1px solid red", marginBottom:"-4px",borderRadius:"10px"}}>Contact</p>: "Contact"}
              </a>
            </div>
            <div className="d-flex m-3 me-0 position-relative">
              <button
                className="btn-search btn border border-secondary btn-md-square rounded-circle bg-white me-4"
                data-bs-toggle="modal"
                data-bs-target="#searchModal"
              >
                <i className="fas fa-search text-primary" />
              </button>

              <a href="/cart" className="position-relative me-4 my-auto">
                <i className="fa fa-shopping-bag fa-2x" />
                <span
                  className="position-absolute bg-secondary rounded-circle d-flex align-items-center justify-content-center text-dark px-1"
                  style={{ top: "-5px", left: 15, height: 20, minWidth: 20 }}
                >
                  3
                </span>
              </a>


              <div className="dropdown my-auto">
                <a
                  href="#"
                  role="button"
                  id="userDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fas fa-user fa-2x" />
                </a>
               {!userId? <ul
                  className="dropdown-menu dropdown-menu-end shadow border-0 mt-2"
                  aria-labelledby="userDropdown"
                  style={{ minWidth: "200px", borderRadius: "10px" }}
                >
                  <li>
                    <h6 className="dropdown-header">Welcome!</h6>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/login">
                      <i className="fas fa-sign-in-alt me-2 text-primary"></i>{" "}
                      Login
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/register">
                      <i className="fas fa-user-plus me-2 text-success"></i>{" "}
                      Register
                    </a>
                  </li>
                </ul>
               : <ul
                  className="dropdown-menu dropdown-menu-end shadow border-0 mt-2"
                  aria-labelledby="userDropdown"
                  style={{ minWidth: "200px", borderRadius: "10px" }}
                >
                   <li className="bg-yellow-300 font-bold cursor-notallowed">
                    <a className="dropdown-item" href="/profile">
                      Welcome! user
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/profile">
                      <i className="fas bi bi-person-fill me-2 text-primary"></i>{" "}
                      Profile
                    </a>
                  </li>
                </ul>}
              </div>
            </div>
          </div>
          }
      </div>
    </div>
  );
};
